/** RFC 0345: whether this tab holds Keyhive events it cannot apply. */

import type { KeyhiveSyncHealth } from '@mod/core/sharing'
import { useEffect, useState } from 'react'
import { useTabRepoBoot } from '../world/repo/TabRepoProvider'

/** The tab's sharing sync health, or undefined when sharing is off. */
export function useSyncHealth(): KeyhiveSyncHealth | undefined {
  const { sharing } = useTabRepoBoot()
  const watch = sharing?.syncHealth
  const [health, setHealth] = useState(() => watch?.health())
  useEffect(() => {
    if (!watch) return
    setHealth(watch.health())
    return watch.subscribe(setHealth)
  }, [watch])
  return health
}

/** What the window says when sync is stuck, or null when it is not. */
export function stuckMessage(
  health: KeyhiveSyncHealth | undefined,
): string | null {
  if (!health?.stuck) return null
  const n = health.pending
  return `Sync is stuck: ${n} sharing ${n === 1 ? 'change' : 'changes'} this browser cannot apply. Some shared work may be missing. Reloading may help.`
}
